import { AccountActivityRow } from '@/renderer/types/accounting';
import React from 'react';
import { formatCurrencyValue } from './accountingReports';

interface AccountActivityTableProps {
  rows: AccountActivityRow[];
}

export function AccountActivityTable({ rows }: AccountActivityTableProps) {
  return (
    <div className="max-h-[560px] overflow-auto rounded-2xl border border-gray-200">
      <table className="min-w-full divide-y divide-gray-200 text-sm">
        <thead className="sticky top-0 bg-gray-50">
          <tr className="text-left text-xs uppercase tracking-wide text-gray-500">
            <th className="px-4 py-3">Date</th>
            <th className="px-4 py-3">Account</th>
            <th className="px-4 py-3">Source</th>
            <th className="px-4 py-3 text-right">Journal entries</th>
            <th className="px-4 py-3 text-right">Journal lines</th>
            <th className="px-4 py-3 text-right">Debits</th>
            <th className="px-4 py-3 text-right">Credits</th>
            <th className="px-4 py-3 text-right">Net activity</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {rows.map((row) => (
            <tr
              key={`${row.account_id}-${row.entry_date}-${row.source_module}`}
            >
              <td className="px-4 py-3 text-gray-600">{row.entry_date}</td>
              <td className="px-4 py-3">
                <p className="font-semibold text-gray-900">
                  {row.account_code} - {row.account_name}
                </p>
                <p className="mt-1 text-xs text-gray-500 capitalize">
                  {row.account_type}
                </p>
              </td>
              <td className="px-4 py-3 text-gray-600">
                <p className="capitalize">{row.source_module}</p>
                <p className="mt-1 text-xs text-gray-500">
                  {row.reference_type || 'No reference type'}
                </p>
              </td>
              <td className="px-4 py-3 text-right text-gray-600">
                {row.journal_entry_count.toLocaleString()}
              </td>
              <td className="px-4 py-3 text-right text-gray-600">
                {row.journal_line_count.toLocaleString()}
              </td>
              <td className="px-4 py-3 text-right font-medium text-gray-700">
                {formatCurrencyValue(row.total_debits)}
              </td>
              <td className="px-4 py-3 text-right font-medium text-gray-700">
                {formatCurrencyValue(row.total_credits)}
              </td>
              <td className="px-4 py-3 text-right font-semibold text-gray-900">
                {formatCurrencyValue(row.net_activity)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
